import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';

import FadedList from '../../../FadedList/FadedList';
import { OptionList, OptionListHeight } from '../OptionList';
import { ShowAllButton } from '../ShowAllButton/component';

import { AudioTracksListProps } from './AudioTracksList.types';
import styles from './AudioTracksList.module.css';

export const TracksList: FC<AudioTracksListProps> = ({
    className,
    titleClassName,
    bodyClassName,
    currentAudioTrack,
    audioTracksWithNotes,
    handleSelectAudioTrack,
    isAllTracksVisible,
    showAllTracks,
}) => (
    <section className={className}>
        <h1 className={titleClassName}>
            <FormattedMessage
                id="components.PlayerSkin.b22f0418e8ac915eb66f829d262d14a2"
                defaultMessage="Audio"
                description="Заголовок списка аудиодорожек"
            />
        </h1>
        <FadedList setElementRef={null} className={bodyClassName} off>
            <OptionList<string>
                value={currentAudioTrack || null}
                onSelect={handleSelectAudioTrack}
                options={audioTracksWithNotes}
                heightType={OptionListHeight.Range}
            />
            {!isAllTracksVisible && (
                <ShowAllButton onClick={showAllTracks} className={styles.showAllContainer} />
            )}
        </FadedList>
    </section>
);
